import { queryElemsFor } from './page-insights/document_lookup';

const scrollableAttributes = ['scroll', 'auto'];

/**
 * Finds the first internal scrolling element given the CSS selectors. Due to pages being able to switch back and forth
 * between internal scrolling and document scrolling, this is also take into consideration if the found element still
 * meets the criteria for internal scrolling.
 */
export function findFirstInternalScrollNode(
  document: Document,
  cssSelectors: string[] = [],
): Element | null {
  // Cooking internal scroll pages can give us some false positives. Pages can switch back and forth on their layouts
  // so check the scroll height of the document vs the reported items. The scroll area can't be used because some items
  // (e.g. carousel) can make the container be reported larger than the document when it's really not.
  let largestElement: Element = document?.documentElement;

  // NOTE: Any changes in this function need to manually be applied in session-image-exporter's exportUtils.ts file as well
  for (const selector of cssSelectors) {
    const foundElements: NodeListOf<Element> = queryElemsFor(document, selector);
    if (foundElements) {
      for (const item of foundElements.values()) {
        if (
          item.scrollHeight > largestElement.scrollHeight &&
          scrollableAttributes.includes(window.getComputedStyle(item).overflowY)
        ) {
          largestElement = item;
        }
      }
    }
  }

  if (largestElement === document?.documentElement) {
    return null;
  }

  return largestElement;
}
